import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { notify } from '@/lib/notify';
import { deliveryDaysError } from './supplierContact';
import { useSupplierBrandTerms, useUpsertBrandTerm } from '../settings/useStoreBrands';

export function SupplierBrandTerms({ slug }: { slug: string }) {
    const terms = useSupplierBrandTerms(slug);
    const save = useUpsertBrandTerm(slug);
    const [draft, setDraft] = useState<Record<string, { min: string; max: string }>>({});

    return (
        <section className="max-w-xl space-y-3">
            <h2 className="text-sm font-semibold">Excepción de plazo por marca</h2>
            <p className="text-xs text-muted-foreground">
                Si la dejas vacía, la marca usa la entrega de este proveedor. La preparación sigue siendo la del proveedor.
            </p>
            {(terms.data ?? []).length === 0 ? (
                <p className="text-sm text-muted-foreground">Este proveedor no tiene marcas de tienda.</p>
            ) : (
                <ul className="space-y-2">
                    {(terms.data ?? []).map((row) => {
                        const current = draft[row.brandId] ?? {
                            min: row.deliveryDaysMin == null ? '' : String(row.deliveryDaysMin),
                            max: row.deliveryDaysMax == null ? '' : String(row.deliveryDaysMax),
                        };
                        return (
                            <li key={row.brandId} className="grid grid-cols-[1fr_5rem_5rem_auto] items-center gap-2">
                                <span className="text-sm">{row.brandName}</span>
                                <Input
                                    inputMode="numeric"
                                    aria-label={`Entrega mínima de ${row.brandName}`}
                                    value={current.min}
                                    onChange={(event) => {
                                        const min = event.target.value;
                                        setDraft((prev) => ({ ...prev, [row.brandId]: { ...current, min } }));
                                    }}
                                />
                                <Input
                                    inputMode="numeric"
                                    aria-label={`Entrega máxima de ${row.brandName}`}
                                    value={current.max}
                                    onChange={(event) => {
                                        const max = event.target.value;
                                        setDraft((prev) => ({ ...prev, [row.brandId]: { ...current, max } }));
                                    }}
                                />
                                <Button
                                    type="button"
                                    size="sm"
                                    variant="outline"
                                    disabled={save.isPending}
                                    onClick={() => {
                                        const error = deliveryDaysError(current.min, current.max);
                                        if (error && (current.min.trim() || current.max.trim())) {
                                            notify({ type: 'err', text: error });
                                            return;
                                        }
                                        const empty = !current.min.trim() && !current.max.trim();
                                        save.mutate(
                                            {
                                                brandId: row.brandId,
                                                daysMin: empty ? null : Number(current.min),
                                                daysMax: empty ? null : Number(current.max),
                                            },
                                            {
                                                onSuccess: () => notify({ type: 'ok', text: `Plazo de ${row.brandName} guardado` }),
                                                onError: (err) => notify({ type: 'err', text: err.message }),
                                            },
                                        );
                                    }}
                                >
                                    Guardar
                                </Button>
                            </li>
                        );
                    })}
                </ul>
            )}
        </section>
    );
}
